document.addEventListener("DOMContentLoaded", function () {
    // Flatpickr Datepicker
    const datepicker = flatpickr("#dateofbirth", {
        dateFormat: "d.m.Y",
        defaultDate: "01.01.2000",
        locale: "de",
        allowInput: true,
    });

    document.querySelector("#datepickerButton").addEventListener("click", function () {
        datepicker.open();
    });

    // JustValidate Form Validation
    const validator = new JustValidate("#childForm", {
        errorFieldCssClass: "is-invalid",
        successFieldCssClass: "is-valid",
        errorLabelCssClass: "invalid-feedback",
    });

    validator
        .addField("#prename", [
            { rule: "required", errorMessage: "Bitte gib einen Vornamen ein." },
            { rule: "minLength", value: 2, errorMessage: "Es werden mindestens 2 Buchstaben benötigt!" },
            { validator: value => !value.includes('/'), errorMessage: "Der Vorname darf das Zeichen / nicht enthalten." }
        ])
        .addField("#surname", [
            { rule: "required", errorMessage: "Bitte gib einen Nachnamen ein." },
            { rule: "minLength", value: 2, errorMessage: "Es werden mindestens 2 Buchstaben benötigt!" },
            { validator: value => !value.includes('/'), errorMessage: "Der Nachname darf das Zeichen / nicht enthalten." }
        ])
        .addField("#dateofbirth", [
            { rule: "required", errorMessage: "Bitte gib ein Geburtsdatum ein." },
            {
                validator: value => /^\d{2}\.\d{2}\.\d{4}$/.test(value),
                errorMessage: "Bitte gib ein gültiges Datum im Format tt.mm.yyyy ein."
            }
        ])
        .onSuccess((event) => {
            console.log("Formular ist gültig!");
            event.target.submit();
        });

    const abletoswimRadios = document.querySelectorAll('input[name="abletoswim"]');
    const swimmingBadgeRadios = document.querySelectorAll('input[name="swimmingbadge"]');
    const swimmingSection = document.getElementById('swimming');

    function updateSwimmingBadgeVisibility() {
        const selected = document.querySelector('input[name="abletoswim"]:checked');
        if (selected && selected.value === "0") {
            swimmingBadgeRadios.forEach(badge => badge.checked = false);
            swimmingSection.classList.add("d-none");
        } else {
            swimmingSection.classList.remove("d-none");
        }
    }

    function updateSwimmingbadgeValidation() {
        const abletoswimParentValue = document.querySelector('input[name="abletoswim"]:checked')?.value;
        // Remove existing validation (safe even if not present)
        try { validator.removeGroup('#swimming'); } catch(e) {}

        if (abletoswimParentValue === "1") {
            validator.addRequiredGroup(
                '#swimming',
                'Bitte wähle ein Schwimmabzeichen aus.'
            );
        }
        validator.refresh();
    }

    abletoswimRadios.forEach(radio => {
        radio.addEventListener('change', function () {
            updateSwimmingBadgeVisibility();
            // Re-apply validation rules:
            updateSwimmingbadgeValidation();
        });
    });

    updateSwimmingBadgeVisibility(); // initialize on page load
    updateSwimmingbadgeValidation(); // initialize on page load
});